export class MailDestinataireContactInput {
  public contactIdiAdmin?: number;
  public contactId?: number; // Its required if the field ServiceDestinataireId has value.It is used to validate destinataire user permission
  public historiqueDescription?: string; // Mail history description, use contact fullname as default value
}
